export default __webpack_public_path__ + "static/media/IMG-20160604-WA0000.be306fbe.jpg";